// extracted by mini-css-extract-plugin
export default {"title":"f8-z","warning":"g8-z","sizeOptionsLegendText":"h8-z"};